import React from 'react';
import { Link } from 'react-router-dom';
import PageSEO from '../components/PageSEO';

const team = [
  { name: 'Hadrien', role: 'Co-fondateur & Gérant', avatar: 'H', bio: 'Ancré dans le Berry depuis de nombreuses années, Hadrien pilote les projets et accompagne chaque client de la première rencontre jusqu\'à la livraison clés en main.' },
  { name: 'Marius', role: 'Co-fondateur & Responsable travaux', avatar: 'M', bio: 'Fort d\'une solide expérience terrain, Marius coordonne les artisans et garantit qualité d\'exécution et respect des délais sur chaque chantier.' },
];

const certifs = [
  /* RGE/Qualibat — à rétablir après obtention qualif
  { label: 'RGE', full: 'Reconnu Garant de l\'Environnement', desc: 'Certification qui vous ouvre droit aux aides de l\'État (MaPrimeRénov\', CEE, éco-PTZ). Obligatoire pour des travaux de rénovation énergétique subventionnés.', icon: '✅' },
  { label: 'Qualibat 9111', full: 'Rénovation énergétique globale', desc: 'Label qui atteste de notre compétence en rénovation énergétique globale. Gage de qualité et de professionnalisme reconnu par tous les acteurs du secteur.', icon: '🏅' },
  */
  { label: 'Garantie Décennale', full: 'Responsabilité 10 ans', desc: 'Tous nos travaux sont couverts par notre assurance de responsabilité décennale. En cas de malfaçon, vous êtes protégés pendant 10 ans après réception des travaux.', icon: '🛡️' },
];

export default function APropos() {
  return (
    <>
      <PageSEO
        title="À propos — Artisans du Berry depuis 2025"
        path="/a-propos"
        description="Hadrien et Marius ont fondé Apex Rénovation à Châteauroux. Artisans ancrés dans le Berry, engagés pour la rénovation de qualité dans l'Indre et le Cher. Garantie décennale."
      />
      <section className="bg-slate-900 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-sm text-slate-400 mb-4 flex items-center gap-2">
            <Link to="/" className="hover:text-orange-400">Accueil</Link><span>/</span>
            <span className="text-white">À propos</span>
          </div>
          <h1 className="text-4xl font-extrabold text-white mb-3">L'histoire d'Apex Rénovation</h1>
          <p className="text-slate-400 text-lg max-w-2xl">Fondée à Châteauroux en 2025, Apex Rénovation s'impose comme le partenaire de confiance pour la rénovation résidentielle et commerciale dans tout le Berry.</p>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="lg:grid lg:grid-cols-2 lg:gap-16 items-center">
            <div>
              <span className="text-orange-600 font-semibold text-sm uppercase tracking-wider">Notre histoire</span>
              <h2 className="text-3xl font-bold text-slate-900 mt-2 mb-5">Ancrés dans le Berry, engagés pour le faire vivre</h2>
              <p className="text-slate-600 leading-relaxed mb-5">
                Hadrien et Marius ont fondé Apex Rénovation en 2025 avec une conviction : le Berry mérite des artisans qui connaissent vraiment son territoire et ses habitants. Tous deux profondément ancrés dans la région, ils s'engagent au quotidien pour contribuer à sa vitalité.
              </p>
              <p className="text-slate-600 leading-relaxed mb-5">
                Apex Rénovation a déjà accompagné la transformation de nombreux espaces : cabinets dentaires (Oasis Santé), restaurants, commerces et boutiques, mais aussi des maisons de particuliers — embellissement, rénovation pour investisseurs locatifs, préparation avant vente, isolation énergétique… Chaque projet, quelle que soit sa taille, bénéficie du même niveau d'exigence.
              </p>
              <div className="grid grid-cols-3 gap-6 mt-8">
                {[['2025', 'Fondation'], ['Berry', 'Notre territoire'], ['100%', 'Engagés']].map(([val, label]) => (
                  <div key={label} className="text-center">
                    <div className="text-3xl font-extrabold text-orange-600">{val}</div>
                    <div className="text-slate-500 text-sm mt-1">{label}</div>
                  </div>
                ))}
              </div>
            </div>
            <div className="mt-10 lg:mt-0">
              <img src="/founders.webp" alt="Hadrien et Marius, co-fondateurs d'Apex Rénovation" className="w-full rounded-2xl shadow-xl" />
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <span className="text-orange-600 font-semibold text-sm uppercase tracking-wider">L'équipe</span>
            <h2 className="text-3xl font-bold text-slate-900 mt-2">Des artisans passionnés</h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 max-w-2xl mx-auto">
            {team.map((m) => (
              <div key={m.name} className="bg-white rounded-2xl p-6 border border-slate-200 text-center hover:shadow-md transition-shadow">
                <div className="w-20 h-20 rounded-full bg-orange-600 flex items-center justify-center text-white text-2xl font-bold mx-auto mb-4">{m.avatar}</div>
                <h3 className="font-bold text-slate-900 text-lg mb-1">{m.name}</h3>
                <p className="text-orange-600 text-sm font-semibold mb-3">{m.role}</p>
                <p className="text-slate-500 text-sm">{m.bio}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <span className="text-orange-600 font-semibold text-sm uppercase tracking-wider">Certifications</span>
            <h2 className="text-3xl font-bold text-slate-900 mt-2">Nos garanties qualité</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {certifs.map((c) => (
              <div key={c.label} className="text-center p-8 border border-slate-200 rounded-2xl hover:border-orange-300 hover:shadow-md transition-all">
                <div className="text-5xl mb-4">{c.icon}</div>
                <div className="font-black text-2xl text-slate-900 mb-1">{c.label}</div>
                <div className="text-orange-600 font-semibold text-sm mb-4">{c.full}</div>
                <p className="text-slate-500 text-sm leading-relaxed">{c.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-orange-600">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-extrabold text-white mb-4">Prêt à travailler ensemble ?</h2>
          <Link to="/devis" className="bg-white text-orange-600 font-bold px-8 py-4 rounded-lg hover:bg-orange-50 transition-colors inline-block">Demander un devis gratuit</Link>
        </div>
      </section>
    </>
  );
}
